import { render } from "./carrierScreening.vue?vue&type=template&id=206d57aa"
import script from "./carrierScreening.vue?vue&type=script&lang=js"
export * from "./carrierScreening.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__